import { render } from "./IconLinkOff.vue?vue&type=template&id=52fd5125"
import script from "./IconLinkOff.vue?vue&type=script&lang=js"
export * from "./IconLinkOff.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__